module.exports = __webpack_public_path__ + "img/cross.bd938b3c.svg";